import AbstractResults from "components/AAIR/AbstractResults";

const ResultHistory = () => {
  return (
    <div className="p-4">
      <AbstractResults />
    </div>
  )
}
export default ResultHistory;